import { render, staticRenderFns } from "./CambioButacaPasoConfirmacionPago.vue?vue&type=template&id=5f67d444"
import script from "./CambioButacaPasoConfirmacionPago.vue?vue&type=script&setup=true&lang=js"
export * from "./CambioButacaPasoConfirmacionPago.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports